/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EVehicleDriverPanelTabs {
  VehicleList = 0,
  VehicleStatus,
  DriverStatus
}
